/* eslint-disable no-unused-vars */
import React from 'react';
import { SketchPicker, HuePicker } from 'react-color';
import classNames from 'classnames/bind';
import styles from './ColorPicker.module.scss';
const cx = classNames.bind(styles);
import PropTypes from 'prop-types';

// eslint-disable-next-line react/prop-types
function ColorPicker({ config, expanded, onExpandEvent, onChange, currentState, doExpand, doCollapse }) {
    const { color } = currentState;

    const popover = {
        position: 'absolute',
        zIndex: '2',
        left: '81px',
    };

    const cover = {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
    };

    const renderModal = () => {
        return (
            <div
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                <div style={popover}>
                    <div
                        style={cover}
                        onClick={doCollapse}
                    />
                    <SketchPicker
                        color={color}
                        onChangeComplete={(color) => {
                            onChange('color', color.hex);
                            doExpand();
                        }}
                    />
                </div>
            </div>
        );
    };

    return (
        <div
            className={cx('demo-color-wrapper')}
            aria-haspopup="true"
            aria-expanded={expanded}
            aria-label="rdw-color-picker"
        >
            <div
                onClick={onExpandEvent}
                className={cx('demo-icon-wrapper')}
            >
                <img
                    className={cx('demo-icon')}
                    src={
                        'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNDA2LjU4NWExLjk5OCAxLjk5OCAwIDAgMC0yLjgyNSAwbC0uNTQuNTRhLjc0MS43NDEgMCAxIDAtMS4wNDggMS4wNDhsLjE3NS4xNzUtNS44MjYgNS44MjUtMi4wMjIgMi4wMjNhLjkxLjkxIDAgMCAwLS4yNjYuNjAybC0uMDA1LjEwOHYuMDAybC0uMDgxIDEuODI5YS4zMDIuMzAyIDAgMCAwIC4zMDIuMzE2aC4wMTNsLjk3LS4wNDQuNTkyLS4wMjYuMjY4LS4wMTJjLjI5Ny0uMDEzLjU3OS0uMTM3Ljc5LS4zNDdsNy43Ny03Ljc3LjE0Ni4xNDRhLjc0Ljc0IDAgMCAwIDEuMDQ4IDBjLjI5LS4yOS4yOS0uNzU5IDAtMS4wNDhsLjU0LS41NGMuNzgtLjc4Ljc4LTIuMDQ0IDAtMi44MjV6TTguNzk1IDcuMzMzbC0yLjczLjUxNSA0LjQ1Mi00LjQ1MiAxLjEwOCAxLjEwNy0yLjgzIDIuODN6TTIuMDggMTMuNjczYy0xLjE0OCAwLTIuMDguMjk1LTIuMDguNjYgMCAuMzYzLjkzMi42NTggMi4wOC42NTggMS4xNSAwIDIuMDgtLjI5NCAyLjA4LS42NTkgMC0uMzY0LS45My0uNjU5LTIuMDgtLjY1OXoiLz48L2c+PC9zdmc+'
                    }
                    alt=""
                />
            </div>
            {expanded ? renderModal() : undefined}
        </div>
    );
}

ColorPicker.defaultProps = {
    expanded: null,
};
ColorPicker.propTypes = {
    expanded: PropTypes.bool,
    onExpandEvent: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    currentState: PropTypes.object.isRequired,
    doExpand: PropTypes.func.isRequired,
    doCollapse: PropTypes.func.isRequired,
    config: PropTypes.object.isRequired,
};

export default ColorPicker;
